import ZellePage from "components/pages/ZellePage";
import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

export default function CaptureQuickTourZelle(props) {
    const context = useBCMSContext();
    const { branding } = context.state;
    const { options } = branding ?? {};
    BCMSRecord.globalControllerFor(Classes, context);
    const hasZelle = options.zle_abi22 === "true";

    if(!hasZelle) {
        const message = `This capture is only shown when "*Zelle" is set to "Yes".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <ZellePage />;
}